<template>
  <v-page-content>
    <div class="w-50 m-auto" style="text-align: justify;">
      <h3><strong>Подробнее о cookie-файлах</strong></h3>
      <h4>Что такое файлы cookies?</h4>
      Cookie — это текстовые файлы, содержащие небольшой объем информации, которые отправляются вашему браузеру и хранятся на компьютере, мобильном телефоне или другом устройстве, с которого вы заходите на сайт. Файлы cookies отправляют информацию на сайт при каждом его посещении.
      Файлы cookies могут быть вечными (они называются постоянными файлами cookies) и храниться в компьютере, пока вы их не удалите, или временными (такие файлы cookies называются сессионными), то есть сохраняющимися только до закрытия браузера. Кроме того, файлы cookies подразделяются на основные (они устанавливаются непосредственно посещаемым сайтом) и сторонние (устанавливаются другими сайтами).
      <br><br>
      <h4>Каким образом сайт использует файлы cookies?</h4>
      Мы используем файлы cookies для улучшения работы сайтов, более эффективной навигации по страницам, запоминания настроек и облегчения взаимодействия с пользователем.
    </div>
  </v-page-content>
</template>

<script>
export default {
  name: 'CookiesInfo'
}
</script>

<style scoped>

</style>
